var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"2"}},[_c('AdminMenu')],1),_c('v-col',{attrs:{"cols":"10"}},[_c('v-container',{attrs:{"grid-list-lg":"","py-0":""}},[_c('transition',{attrs:{"name":"fade-transition","mode":"out-in"}},[_c('router-view')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }